export default '/static/frontend/ReachDigital/12gobiking/dist/assets/bank-transfer-d24874db.png'